module.exports = __webpack_public_path__ + "img/logo_syngenta.92d7e078.png";